// Shared by Cloud Functions and the frontend (imported there as @shared).
// Quad cutoffs: the NCAA's, for 362 teams, scaled to the league's size.

const NCAA_TEAMS = 362;
const NCAA_CUTOFFS = {
  home: [30, 75, 160],
  neutral: [50, 100, 200],
  away: [75, 135, 240],
};

/**
 * The worst opponent rank that still counts as quad 1, 2 and 3 at home,
 * at a neutral site and away. Anything worse is quad 4.
 * @param {number} teamCount
 * @return {object} {home, neutral, away}: three cutoffs each
 */
export function quadCutoffs(teamCount) {
  const scale = teamCount / NCAA_TEAMS;
  const cut = (list) => list.map((n) => Math.max(1, Math.round(n * scale)));
  return {
    home: cut(NCAA_CUTOFFS.home),
    neutral: cut(NCAA_CUTOFFS.neutral),
    away: cut(NCAA_CUTOFFS.away),
  };
}
